// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ExportDataDownloadResponseFromJSON(json) {
    return {
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}
export function ExportDataDownloadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fileName': value.fileName,
        'contentType': value.contentType,
        'content': value.content,
    };
}
